const hexChar = '[a-zA-Z0-9]';

export function makeHexCharGroup(nChars: number): string {
    return `(?:${hexChar}{${nChars}})`;
}

const h = makeHexCharGroup;
export const guidPattern = `^${h(8)}-${h(4)}-${h(4)}-${h(4)}-${h(12)}$`;

export function isGuid(maybeGuid: string): boolean {
    const guidRegexp = RegExp(guidPattern);
    return guidRegexp.test(maybeGuid);
}
